<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M17.4 30.7029C16.8 30.7029 16.2 30.3029 15.9 29.7029L12.9 24.2029H9.3C8.3 24.2029 7.5 23.2029 
    7.5 22.0029C7.6 20.9029 8.4 19.9029 9.3 19.9029H13.8C14.4 19.9029 15 20.3029 15.3 20.9029L17.2 
    24.3029L21.2 14.7029C21.5 14.0029 22.1 13.5029 22.7 13.5029C23.4 13.5029 24 13.9029 24.3 
    14.5029L29.1 24.3029L30.2 24.3C31.2 24.3 32 25.3 32 26.5C32 27.7 31.2 28.7 30.2 28.7L28 
    28.7029C27.4 28.7029 26.8 28.3029 26.5 27.7029L22.8 20.3029L19 29.5029C18.7 30.2029 18.1 30.6029 
    17.5 30.7029C17.4 30.7029 17.4 30.7029 17.4 30.7029Z"
    fill="#009DD6"
  />
  <path
    d="M10.5002 12.6028C13.7002 12.6028 16.3002 10.0028 16.3002 6.80279C16.3002 3.60279 13.7002 1.00279 
    10.5002 1.00279C7.3002 0.902791 4.7002 3.50279 4.7002 6.70279C4.7002 10.0028 7.3002 12.6028 10.5002 12.6028Z"
    fill="#748097"
  />
  <path
    d="M5.6 22.0027C5.6 19.7027 7.3 17.8027 9.4 17.8027H13.9C15.1 17.8027 16.3 18.4027 17 19.5027L18.5 
    15.8027C17.6 15.2027 16.5 14.8027 15.3 14.8027H5.8C2.6 14.9027 0 17.5027 0 20.7027V24.5027C0 25.0027 
    0.4 25.4027 0.9 25.4027H7.2C6.2 24.6027 5.6 23.4027 5.6 22.0027Z"
    fill="#748097"
  />
</svg>
